import React from "react";
import { Box, Card, Skeleton, Paper } from "@mui/material";

const ProcessSkeleton: React.FC = () => {
  return (
    <Box
      sx={{
        height: "100vh",
        backgroundColor: "#f8f9fa",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          overflowX: "hidden",
          p: { xs: 1, sm: 2 },
        }}
      >
        {/* Header Skeleton */}
        <Box sx={{ mb: 3 }}>
          <Skeleton variant="text" width={300} height={40} sx={{ mb: 2 }} />

          {/* Tabs Skeleton */}
          <Paper
            sx={{
              mb: 3,
              borderRadius: 2,
              boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
              overflow: "hidden",
              p: 1,
            }}
          >
            <Box sx={{ display: "flex", justifyContent: "space-around" }}>
              <Skeleton variant="rectangular" width={100} height={40} />
              <Skeleton variant="rectangular" width={100} height={40} />
              <Skeleton variant="rectangular" width={100} height={40} />
            </Box>
          </Paper>

          {/* Alert Skeleton */}
          <Card
            sx={{
              mb: 3,
              p: 2,
              backgroundColor: "rgba(255,255,255,0.95)",
              borderRadius: 2,
              boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
            }}
          >
            <Skeleton variant="text" width="80%" height={24} />
          </Card>
        </Box>

        {/* Category Cards Skeleton */}
        {[1, 2, 3].map(index => (
          <Card
            key={index}
            sx={{
              mb: { xs: 2, sm: 3 },
              borderRadius: 2,
              boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
            }}
          >
            <Box
              sx={{
                background:
                  "linear-gradient(145deg,#36276f,#4c3699 50%,#36276f)",
                p: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Skeleton
                  variant="text"
                  width={200}
                  height={28}
                  sx={{ bgcolor: "rgba(255,255,255,0.2)" }}
                />
                <Skeleton
                  variant="text"
                  width={150}
                  height={20}
                  sx={{ bgcolor: "rgba(255,255,255,0.1)", mt: 1 }}
                />
              </Box>
              <Skeleton
                variant="rectangular"
                width={100}
                height={36}
                sx={{ bgcolor: "rgba(255,255,255,0.2)", borderRadius: 2 }}
              />
            </Box>

            <Box sx={{ p: 3, backgroundColor: "#f8f9fa" }}>
              {/* Process Cards Skeleton */}
              {[1, 2].map(processIndex => (
                <Card
                  key={processIndex}
                  sx={{
                    mb: 2,
                    backgroundColor: "#ffffff",
                    borderRadius: 2,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                    p: 2,
                  }}
                >
                  {/* Step Items Skeleton */}
                  {[1, 2, 3].map(stepIndex => (
                    <Box
                      key={stepIndex}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        mb: stepIndex < 3 ? 1 : 0,
                        p: 1,
                      }}
                    >
                      <Skeleton variant="circular" width={24} height={24} />
                      <Skeleton variant="text" width="60%" height={20} />
                      <Box sx={{ marginLeft: "auto" }}>
                        <Skeleton
                          variant="rectangular"
                          width={80}
                          height={24}
                          sx={{ borderRadius: 1 }}
                        />
                      </Box>
                    </Box>
                  ))}
                </Card>
              ))}
            </Box>
          </Card>
        ))}
      </Box>
    </Box>
  );
};

export default ProcessSkeleton;
